import { msg, str } from '@lit/localize';
import { html, nothing } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';

import '@spectrum-web-components/icons-workflow/icons/sp-icon-attach.js';

import type { ConversationAttachment, ConversationMessage } from './types.js';

function getAttachmentStatusLabel(
  attachment: ConversationAttachment
): string | undefined {
  const custom = attachment.message?.trim();
  if (custom) {
    return custom;
  }
  switch (attachment.status) {
    case 'saved':
      return msg('Saved to DATEV DMS.');
    case 'failed':
      return msg('Failed to save to DATEV DMS.');
    case 'ignored':
      return msg('Attachment ignored.');
    case 'pending':
      return msg('Processing...');
    default:
      return undefined;
  }
}

export function renderMessageExtras(message: ConversationMessage) {
  return html`
    ${
      message.attachments?.length
        ? message.attachments.map(
            (attachment) => html`<div class="attachments">
              <sp-icon-attach></sp-icon-attach>
              <div
                class="meta"
                title=${ifDefined(getAttachmentStatusLabel(attachment))}
              >
                ${
                  attachment.url
                    ? html`<a
                        href="${attachment.url}"
                        target="_blank"
                        rel="noopener"
                      >
                        ${attachment.name}
                      </a>`
                    : html`<span>${attachment.name}</span>`
                }
              </div>
            </div>`
          )
        : nothing
    }
    ${
      !message.attachments?.length &&
      message.attachmentsCount &&
      message.attachmentsCount > 0
        ? html`<div class="attachments">
            <sp-icon-attach></sp-icon-attach>
            <span>${msg(str`${message.attachmentsCount} files attached`)}</span>
          </div>`
        : nothing
    }
    ${
      message.imageUrl
        ? html`<img
            class="image-attachment"
            src="${message.imageUrl}"
            alt=${msg('Attachment')}
            loading="lazy"
          />`
        : message.imagePlaceholder
          ? html`<div class="image-ph">${msg('Image placeholder')}</div>`
          : nothing
    }
  `;
}
